import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Link } from "@material-ui/core";
import ButtonAtom from '../../component/ButtonAtom/index.jsx'
import { makeStyles } from '@material-ui/styles';
import OtpInput from "react-otp-input";
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@material-ui/core/IconButton';
import firebase from "../../config/firebase/index";
import { useHistory } from 'react-router-dom';
import Loader from '../../component/Loader/index.jsx';
// import Spinner from 'react-bootstrap/Spinner';
import CircularIndeterminate from './../../component/Loader/index';
import TextfieldAtom from '../../component/Textfield/index.jsx';
import ReactGA from 'react-ga';
import Login from '../login/Login.js';
import CheckBox from '../../component/CheckboxAtom/index.jsx';

const Otp_Verification = (props) => {
  const {
    sentOtp,
    number,
    slimMode = false,
  } = props
  const history = useHistory();
  const classes = useStyles();
  const [Otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [mobileField, setMobileField] = useState(false);
  const [verify, setVerify] = useState(false);
  const [error, setError] = useState(false);

  // useEffect(() => {
  //   localStorage.setItem("Phone Number", number);
  // });

  const checkedTnC = (val) => {
    console.log("Selected Val :: ", val);
    setVerify(val);
  }

  const AccountValidation = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  const OtpInvalid = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  const OtpResend = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  const LoginButton = (category, action, label) => {
    console.log("GA event:", category, ":", action, ":", label);
    ReactGA.event({
      category: category,
      action: action,
      label: label,
    })
  }

  function refreshPage() {
    window.location.reload(false);
  }

  const existingUser = () => {
    setLoading(true);
    firebase.database().ref("Users").orderByChild("PhoneNo")
      .equalTo(localStorage.getItem("Phone Number")).once("value", snapshot => {
        const userData = snapshot.val();
        const user = [];
        for (const key in userData) {
          const quoteObj = {
            id: key,
            ...userData[key],
          };
          user.push(quoteObj);
        }
        if (userData) {
          localStorage.setItem("isLoggedIn", true);
          localStorage.setItem("user", JSON.stringify(user));
          setLoading(false);

          history.push("/marketView");
        }
        else {
          setLoading(false);
          AccountValidation("Login", "Validation", "Account does not exist");
          history.push("/signup");
          localStorage.setItem("isLoggedIn", true);

        }

      })
  }

  const otpHandleChange = (otp) => {
    setOtp(otp);
  };

  const signin = () => {
    firebase
      .auth()
      .signInWithPhoneNumber("+91" + number, window.recaptchaVerifier)
      .then((confirmationResult) => {
        window.confirmationResult = confirmationResult;
        // OtpResend("Login", "click", "Re-send OTP");
        // setfinal(confirmationResult);
        // verification();

      })
      .catch((error) => {

        // window.recaptchaVerifier.clear()
        console.log("error", error);

      });
  };



  const ValidateOtp = () => {
    setLoading(true);
    if (Otp === null || sentOtp === null) return;
    window.confirmationResult
      .confirm(Otp)
      .then((result) => {
        existingUser();
        // {<Spinner animation="border" variant="primary" />}

      })
      .catch((err) => {
        setLoading(false);
        OtpInvalid("Login", "Validation", "Invalid OTP");
        setVerify(false);
        alert("Wrong code");

      });
  };

  const validate = () => {
    if (verify) {
      ValidateOtp();
      LoginButton("Login", "click", "Login Button");
      setError(false);
    } else
      setError(true);
  }

  if (!slimMode) {
    return (
      <>

        {loading ? <CircularIndeterminate /> :
          <Grid className={classes.commonFullSection}>
            <Grid className={classes.commonMidSection} >
              <Typography variant="h4" style={{ fontWeight: 600 }} gutterBottom className={classes.purpuleColor}>
                सौदेबाज़ी
              </Typography>
              <Typography variant="h6" style={{ fontWeight: 600 }} gutterBottom>
                अपने नंबर की पुष्टि करे
              </Typography>
              <Typography variant="body2" gutterBottom className={classes.top}>
                कृपया {number} पर भेजा गया ओटीपी दर्ज करे
              </Typography>

              <Box >

                <Typography variant="body1" style={{ fontWeight: 600 }} gutterBottom className={classes.purpuleColor}>
                  नंबर edit करे<IconButton onClick={refreshPage}><EditIcon /></IconButton>
                </Typography>


              </Box>

              <Box className={classes.otpBoxUi}>
                <OtpInput
                  numInputs={6}
                  className={classes.otp}
                  value={Otp}
                  onChange={otpHandleChange}
                  autocomplete="one-time-code"
                  isInputNum={true}
                  // type="number"
                  type="text"
                  inputMode="numeric"
                  pattern="[+-]?\d+(?:[.,]\d+)?"
                />
              </Box>

              {/* <Box>
                <TextfieldAtom style={{ fontSize: '16px' }}
                  onChange={otpHandleChange}
                  keyboardType={'numeric'}
                  type="number"
                  inputMode="numeric" />
              </Box> */}

              <Typography variant="body1" gutterBottom className={classes.purpuleColor}>
                ओटीपी नहीं आया <b onClick={() => { signin(); OtpResend("Login", "click", "Re-send OTP"); }}>पुनः भेजे</b>
              </Typography>

              <CheckBox checkedTnC={checkedTnC}
                label={
                  <div>
                    <span>By using the platform the user agrees to the  </span>
                    <a href={'/t&c'}>terms and conditions</a>
                    <span> and </span>
                    <a href={'/privacy-policy'}>privacy policy</a>
                    <span> and  of the company.</span>
                  </div>
                }
              />
              <Typography variant="body" gutterBottom className={classes.labelAlign2} style={{ color: 'red', display: (!verify && error) ? "block" : "none" }}>
                कृपया नियम और शर्तें स्वीकार करें।
              </Typography>

              <ButtonAtom
                name=" पुष्टि करे "
                onClick={validate}
                cclass={verify ? "btnWithRedStatic" : "disabledBtnColor"}
              />
            </Grid>
            <Typography variant="caption" gutterBottom className={classes.marginTopAuto}>
              किसी भी मदद के लिए 8696965308 पर कॉल करें
            </Typography>
            {/* <Grid className={classes.commonFullSection} style={{ display: show ? "block" : "none" }}>
        <SignUp number={number} />
      </Grid> */}
          </Grid>
        }
      </>
    )
  }
  else {
    return (
      <>
        <Box className={classes.otpBoxUi}>
          <OtpInput
            numInputs={6}
            className={classes.otp}
            value={Otp}
            onChange={otpHandleChange}
            autocomplete="one-time-code"
            keyboardType={'numeric'}
            isInputNum={true}
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
          />
        </Box>

        {/* <Box>
          <TextfieldAtom style={{ fontSize: '16px' }}
            onChange={otpHandleChange}
            keyboardType={'numeric'}
            type="number"
            inputMode="numeric" />
        </Box> */}

        <Typography variant="body1" gutterBottom className={classes.purpuleColor}>
          ओटीपी नहीं आया <b onClick={() => { signin(); OtpResend("Login", "click", "Re-send OTP"); }}>पुनः भेजे</b>
        </Typography>


        <ButtonAtom
          name=" पुष्टि करे "
          onClick={ValidateOtp}
          cclass="btnWithRedStatic"

        />
      </>)
  }
}

const useStyles = makeStyles(() => ({
  commonFullSection: {
    width: '100%',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  commonMidSection: {
    maxWidth: 540,
    background: '#fff',
    // boxShadow: '0 0 5px #eee',
    padding: 20,
    boxSizing: 'border-box',
    textAlign: 'center',
    justifyContent: 'center',
    marginTop: 'auto',
    width: 'calc(100% - 60px)',
  },
  marginTopAuto: {
    marginTop: 'auto',
  },
  labelAlign: {
    textAlign: 'left',
    marginTop: 30
  },
  purpuleColor: {
    color: '#53252f',
    marginTop: 'auto'
  },
  otp: {
    size: 16,
    margin: 'auto 5px',
    '& input': {
      width: '36px !important',
      minHeight: 50,
      border: '0 !important',
      background: 'rgba(83, 37, 47, 0.05)',
      borderRadius: 4,
      color: '#000',
      boxSizing: 'border-box',
    }
  },
  top: {
    marginTop: 'auto',
  },
  otpBoxUi: {
    justifyContent: 'center',
    margin: '30px 0',
    boxSizing: 'border-box',
    display: 'flex',

  },
  spacingLess: {
    marginRight: '10px',
  },
  notMoveText: {
    maxWidth: 540,
    background: '#fff',
    boxShadow: '0 0 5px #eee',
    padding: 20,
    boxSizing: 'border-box',
    textAlign: 'center',
    marginTop: 'auto',
    width: 'calc(100% - 60px)',
  },
  punnOtpBheje: {
    textDecoration: 'none',
    color: "#53252f",
  }
}));

export default Otp_Verification;